import { render, staticRenderFns } from "./ArtistArchive.vue?vue&type=template&id=7b4b6fa7&"
import script from "./ArtistArchive.vue?vue&type=script&lang=js&"
export * from "./ArtistArchive.vue?vue&type=script&lang=js&"
import style0 from "./ArtistArchive.vue?vue&type=style&index=0&id=7b4b6fa7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports